import en from './en/index'
import fi from './fi/index'
import sv from './sv/index'

export default {
	default: 'en',
    en: en,
    fi: fi,
    sv: sv
}


// WEBPACK FOOTER //
// ./lang/language.js